export default "__VITE_ASSET__16fa0f25__"